import * as React from "react";
import type { SVGProps } from "react";
const SvgBarChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.8 19.2v-2.4m7.2 2.4v-8.4m7.2 8.4V4.8"
    />
  </svg>
);
export default SvgBarChart01;
